import React from "react";
import "./Checkbox.scss";
const mainClass = "checkbox";

const Checkbox = ({ title, value, handleChange }) => {
  return (
    <div className={mainClass}>
      <input
        className={mainClass + "-check"}
        type="checkbox"
        defaultChecked={value}
      />
      <label
        className={`${mainClass}-lable ${
          value ? `${mainClass}-checkeActive` : ""
        }`}
        onClick={() => handleChange(!value)}
      >
        {title}
      </label>
    </div>
  );
};

export default Checkbox;
